import script from "./Membership.vue?vue&type=script&setup=true&lang=ts"
export * from "./Membership.vue?vue&type=script&setup=true&lang=ts"

import "./Membership.vue?vue&type=style&index=0&id=895a21ce&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-895a21ce"]])

export default __exports__